"use client"
import { BlockRenderer, Container, CustomBreadcrumbs, TopBanner } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import ConferenceVideoMain from "./ConferenceVideoMain"

type Props = {
  data: any
  additional: string
  locale: string
}
function ConferenceVideo({ data, additional, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    conferenceVideoMain: ConferenceVideoMain,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )

  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
            additional,
          }
        } else {
          additionalProps = {
            additional,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            props={additionalProps}
            components={components}
          />
        )
      })}
    </>
  )
}

export default ConferenceVideo
